import React, { Component, useEffect, useState, useRef } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import auth from "../../services/authService";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import UploadRepository from "../../app/components/Document/UploadRepository";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import {
  ddrmsRepoDocumentUploaded,
  getDdrmsRepositoryDocuments,
  getDdrmsRepoUploadStatus,
  loadDdrmsRepositoryDocs,
  UploadDdrmsRepositoryDocs,
} from "../../app/store/ddrmsDocument";
import {
  getLocalDocUploadSasUrl,
  getLocalDocUploadStatus,
  getUploadDocumentId,
  localDocumentUploaded,
  uploadDocument,
  uploadLocalDocument,
} from "../../app/store/documents";
import UploadLocal from "../../app/components/Document/UploadLocal";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../app/store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../app/store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../app/store/candidate";

const CandidateReqDoc = (props) => {
  const {
    docShowHide,
    handleDocShowHide,
    sendType,
    workItem,
    uploadType,
    applicantObj,
    viewType,
    uploadDocType,
    prevItem
  } = props;

  const [submitProcess, setSubmitProcess] = useState(false);
  const [useType, setUseType] = useState("sharing");
  const [isPwd, setIsPwd] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [localDocs, setLocalDocs] = useState([]);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [wfTask, setWfTask] = useState(null);
  const [repoDocs, setRepoDocs] = useState([]);
  const [repoLoading, setRepoLoading] = useState(sendType === "repository");
  const repositoryLoadStartedRef = useRef(false);

  const ddrmsRepoUploadStatus = useSelector(getDdrmsRepoUploadStatus);
  const localDocUploadStatusSelector = useSelector(getLocalDocUploadStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);


  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    setMessage("");
    setLocalDocs([]);
    setSelectedRepoDocs([]);
    setIsPwd("");
    setUseType("");
  }, [docShowHide]);

  useEffect(() => {
    setRepoDocs(ddrmsRepositoryDocumentsSelector);
    if (repositoryLoadStartedRef.current) {
      setRepoLoading(false);
      repositoryLoadStartedRef.current = false;
    }
  }, [ddrmsRepositoryDocumentsSelector]);

  useEffect(() => {
    if (workItem?.ciid > 0) {
      if (sendType === "repository") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(workItem.ciid));
      }
      setWfTask(workItem);
    }
    else if (applicantObj?.id) {
      if (prevItem?.applications?.length > 0 && sendType === "repository") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(prevItem.applications[0].ciid));
      }

      if (uploadType === "Subcontractor") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.subcontractor?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Recruiter") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.recruiter?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadRecruiterWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Candidate") {
        dispatch(loadCandidateWfTask(applicantObj?.id));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
  }, [])

  useEffect(() => {
    if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      setWfTask(subsCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    }
    else if (subsCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(subsCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      setWfTask(recCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    } else if (recCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(recCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadRecruiterWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    console.log(candidateCurrentWfTaskSelector)
    if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      setWfTask(candidateCurrentWfTaskSelector)
      setWfTaskReqCount(0)
    } else if (candidateCurrentWfTaskSelector === 0 && !workItem && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1)
      dispatch(candidateCurrentWfTaskReceived(null));
      setTimeout(() => {
        dispatch(loadCandidateWfTask(applicantObj?.id));
      }, 1000);
    }
  }, [candidateCurrentWfTaskSelector]);


  const doSubmit = async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Upload this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setSubmitProcess(true);
      setTimeout(() => {
        let docType = "";
        if (uploadType) docType = uploadType;
        if (uploadDocType) docType = uploadDocType;
        if (sendType === "repository") saveRepoDocs(docType);
        if (sendType === "upload") saveLocalDocs(docType);
      }, 1000);
    }
  };

  const saveRepoDocs = async (docType) => {
    let task = { ...wfTask };
    task.performerId = currentUser.id;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.applicantId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        task.applicantId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.applicantId = applicantObj?.id;
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    //frmData.append("userId", usrId);
    const updDocs = selectedRepoDocs.map((doc) => {
      const newDoc = { ...doc };
      newDoc.docType = docType;
      return newDoc;
    });
    frmData.append("doc", JSON.stringify(updDocs));
    dispatch(UploadDdrmsRepositoryDocs(frmData));
  };

  useEffect(() => {
    if (ddrmsRepoUploadStatus) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
      dispatch(ddrmsRepoDocumentUploaded({ status: false }));
    }
  }, [ddrmsRepoUploadStatus]);

  const saveLocalDocs = async (docType) => {
    const task = { ...wfTask };
    //wfTask.performerId = workItem.applicantId;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.performerId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.performerId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.performerId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        usrId = applicantObj.applicantId;
        task.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      task.performerId = applicantObj?.id;
    }

    if (docType?.includes("req_")) {
      usrId = task.performerId;
      task.performerId = parseInt(currentUser.id);
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid) {
        usrId = applicantObj.recruiter.parentid;
        task.performerId = applicantObj?.id;
      }
      if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid) {
        usrId = applicantObj.subcontractor.parentid;
        task.performerId = applicantObj?.id;
      }
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(task));
    frmData.append("userId", usrId);
    // localDocs.map((file, key) =>
    //   frmData.append("files[" + key + "]", file.file)
    // );
    frmData.append("files", JSON.stringify(localDocs.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
    frmData.append("docType", docType);
    if (!useType) frmData.append("updType", docType);
    else frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    dispatch(uploadLocalDocument(frmData));

  };

  useEffect(() => {
    if (localDocUploadStatusSelector > 0) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
    }
  }, [localDocUploadStatusSelector]);

  useEffect(() => {

    const uploadAllDocuments = async () => {
      if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            localDocs.map((file, key) =>
              uploadFileToBlob(
                file.file,
                localDocUploadSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(localDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [localDocUploadSasUrlSelector]);

  const handlePwdChecked = ({ currentTarget }) => {
    if (currentTarget.checked) {
      if (uploadType === "Subcontractor") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.subcontractor.fuid;
          const pfName = applicantObj.subcontractor.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Recruiter") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.recruiter.fuid;
          const pfName = applicantObj.recruiter.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Candidate") {
        const pfId = applicantObj.performerid;
        const pfName = applicantObj.performername.substring(0, 3).toLowerCase();
        setIsPwd(pfName + pfId);
      }
    } else {
      setIsPwd("");
    }
  };

  const handleUseTypeSelect = ({ currentTarget }) => {
    if (currentTarget.checked) setUseType("internal");
    else setUseType("sharing");
  };

  const showOptions = !(
    uploadType === "msp" ||
    uploadType === "agency" ||
    uploadType === "ProjectInfo" ||
    uploadType?.includes("ach_") ||
    uploadType?.includes("insurance_") ||
    uploadDocType?.includes("req_") ||
    uploadDocType === "reporting"
  );

  return (
    <>
      <style>{`
        .crd-shell,
        .crd-shell button,
        .crd-shell input,
        .crd-shell textarea {
            font-family: "Open Sans", "Segoe UI", Roboto, sans-serif !important;
        }
        .modal-backdrop {
            z-index: 1080 !important;
        }
        .modal {
            z-index: 1090 !important;
        }
        .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
        }
        .modal.fade .crd-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .crd-modal.modal-dialog {
            transform: scale(1) !important;
        }
        .crd-modal {
            max-width: 90% !important;
            width: 1200px !important;
        }
        .crd-modal .modal-content {
            border: 0;
            border-radius: 16px;
            overflow: hidden;
            background: #ffffff;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            height: auto;
            max-height: calc(100vh - 60px);
            display: flex;
            flex-direction: column;
        }
        .crd-shell {
            background: #ffffff;
            display: flex;
            flex-direction: column;
            min-height: 0;
            flex: 1;
        }
        .crd-header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 18px;
            padding: 22px 24px 18px;
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            border-bottom: 1px solid #f1f5f9;
        }
        .crd-header-left {
            display: flex;
            align-items: flex-start;
            gap: 14px;
            min-width: 0;
            flex: 1;
            text-align: left;
        }
        .crd-icon-box {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 18px;
            flex-shrink: 0;
            box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
        }
        .crd-title { font-size: 18px; font-weight: 800; color: #0f172a; line-height: 1.2; margin: 0; }
        .crd-subtitle { font-size: 13px; color: #64748b; margin: 6px 0 0; }
        .crd-meta-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 12px; }
        .crd-meta-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 10px;
            border-radius: 99px;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            color: #475569;
            font-size: 12px;
            font-weight: 700;
        }
        .crd-meta-pill i { font-size: 11px; color: #2563eb; }
        .crd-close-btn {
            width: 38px;
            height: 38px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            border: 1px solid #cbd5e1;
            background: #ffffff;
            color: #475569;
            cursor: pointer;
            transition: all 0.15s ease;
            flex-shrink: 0;
        }
        .crd-close-btn:hover { background: #f8fafc; border-color: #94a3b8; color: #0f172a; transform: translateY(-1px); }
        .crd-body {
            padding: 24px;
            background: #ffffff;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            flex: 1;
            min-height: 0;
            scrollbar-width: thin;
            scrollbar-color: #cbd5e1 transparent;
        }
        .crd-body::-webkit-scrollbar { width: 5px; }
        .crd-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
        .crd-two-col {
            display: flex;
            gap: 24px;
            align-items: stretch;
            width: 100%;
            min-height: 0;
            flex: 1;
        }
        .crd-left-panel {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 16px;
            min-height: 0;
        }

        .crd-right-panel {
            width: 440px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            gap: 20px;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.01);
            text-align: left;
            min-height: 0;
        }
        @media (max-width: 992px) {
            .crd-two-col { flex-direction: column; }
            .crd-right-panel { width: 100%; }
        }
        .crd-form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
            text-align: left;
        }
        .crd-label {
            font-size: 11.5px;
            font-weight: 800;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin: 0;
        }
        .crd-checkbox-card {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 14px;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            background: #ffffff;
            cursor: pointer;
            transition: all 0.2s ease;
            user-select: none;
        }
        .crd-checkbox-card:hover {
            border-color: #cbd5e1;
            background: #f8fafc;
        }
        .crd-checkbox-card.active {
            border-color: #2563eb;
            background: rgba(37, 99, 235, 0.02);
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }
        .crd-checkbox-indicator {
            width: 18px;
            height: 18px;
            border: 2px solid #cbd5e1;
            border-radius: 4px;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-top: 2px;
        }
        .crd-checkbox-indicator::after {
            content: "";
            display: none;
            width: 5px;
            height: 9px;
            border: solid white;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            margin-bottom: 2px;
        }
        .crd-checkbox-card.active .crd-checkbox-indicator {
            background-color: #2563eb;
            border-color: #2563eb;
        }
        .crd-checkbox-card.active .crd-checkbox-indicator::after {
            display: block;
        }
        .crd-checkbox-label-text {
            font-size: 13.5px;
            font-weight: 700;
            color: #1e293b;
        }
        .crd-checkbox-desc {
            font-size: 11.5px;
            color: #64748b;
            margin-top: 4px;
            line-height: 1.4;
        }
        .crd-textarea {
            width: 100%;
            min-height: 100px;
            padding: 10px 14px;
            border-radius: 8px;
            border: 1px solid #cbd5e1;
            background-color: #ffffff;
            color: #0f172a;
            font-size: 13.5px;
            font-weight: 600;
            transition: all 0.15s ease;
            outline: none;
            resize: vertical;
        }
        .crd-textarea:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
        }
        .crd-footer {
            padding: 16px 24px;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
            flex-shrink: 0;
        }
        .crd-btn {
            min-height: 38px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.15s ease;
            white-space: nowrap;
            border: 1px solid #cbd5e1;
            background: #ffffff;
            color: #334155;
        }
        .crd-btn:hover:not(:disabled) {
            background: #f8fafc;
            border-color: #94a3b8;
            transform: translateY(-1px);
        }
        .crd-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
        .crd-btn.primary {
            background: #2563eb;
            border-color: #2563eb;
            color: #ffffff;
        }
        .crd-btn.primary:hover:not(:disabled) {
            background: #1d4ed8;
            border-color: #1d4ed8;
        }
      `}</style>

      <Modal
        show={docShowHide}
        size="xl"
        centered
        scrollable
        onHide={() => handleDocShowHide("")}
        dialogClassName="crd-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="p-0">
          <div className="crd-shell">
            <div className="crd-header">
              <div className="crd-header-left">
                <div className="crd-icon-box">
                  <i className={sendType === "repository" ? "fa fa-database" : "fa fa-upload"} />
                </div>
                <div className="crd-title-block">
                  <h2 className="crd-title">
                    {sendType === "repository" ? "Upload from DDRMS Repository" : "Upload from Local Drive"}
                  </h2>
                  <p className="crd-subtitle">
                    Select reference files and specify visibility settings for the performer.
                  </p>
                  <div className="crd-meta-row">
                    <span className="crd-meta-pill">
                      <i className="fa fa-briefcase" /> Performer: {uploadType?.toUpperCase() || "General"}
                    </span>
                    {workItem?.ciid > 0 && (
                      <span className="crd-meta-pill">
                        <i className="fa fa-hashtag" /> CIID: {workItem.ciid}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="crd-close-btn"
                onClick={() => handleDocShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>
            </div>

            <div className="crd-body">
              {showOptions ? (
                <div className="crd-two-col">
                  <div className="crd-left-panel">
                    {sendType === "repository" ? (
                      <UploadRepository
                        repoDocs={repoDocs}
                        setSelectedRepoDocs={setSelectedRepoDocs}
                        loading={repoLoading}
                      />
                    ) : (
                      <UploadLocal setLocalDocs={setLocalDocs} />
                    )}
                  </div>
                  <div className="crd-right-panel">
                    <label className="crd-label">Upload Settings</label>

                    <div
                      className={`crd-checkbox-card ${useType === "internal" ? "active" : ""}`}
                      onClick={() => handleUseTypeSelect({ currentTarget: { checked: useType !== "internal" } })}
                    >
                      <span className="crd-checkbox-indicator" />
                      <div style={{ flex: 1 }}>
                        <span className="crd-checkbox-label-text">For Internal Purposes Only</span>
                        <div className="crd-checkbox-desc">
                          Restrict file visibility to internal staff only. Candidates won't see this document.
                        </div>
                      </div>
                    </div>

                    {/* <div
                      className={`crd-checkbox-card ${isPwd ? "active" : ""}`}
                      onClick={() => handlePwdChecked({ currentTarget: { checked: !isPwd } })}
                    >
                      <span className="crd-checkbox-indicator" />
                      <div style={{ flex: 1 }}>
                        <span className="crd-checkbox-label-text">Password Protect Document</span>
                        <div className="crd-checkbox-desc">
                          Encrypt file with standard password policy.
                          <div className="text-danger mt-1" style={{ fontSize: "10px", fontWeight: "700" }}>
                            (Format: First 3 letters of applicant's name + starting 3 characters of applicant's ID)
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="crd-form-group">
                      <label htmlFor="message" className="crd-label">Notes / Description</label>
                      <textarea
                        className="crd-textarea"
                        id="message"
                        name="massage"
                        placeholder="Add file details, message guidelines, or context..."
                        onChange={({ currentTarget }) => setMessage(currentTarget.value)}
                        value={message}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {sendType === "repository" ? (
                    <UploadRepository
                      repoDocs={repoDocs}
                      setSelectedRepoDocs={setSelectedRepoDocs}
                      loading={repoLoading}
                    />
                  ) : (
                    <UploadLocal setLocalDocs={setLocalDocs} />
                  )}
                </div>
              )}
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer className="crd-footer">
          <button
            type="button"
            className="crd-btn"
            onClick={() => handleDocShowHide("")}
          >
            <i className="fa fa-times" /> Close
          </button>
          <button
            type="button"
            className="crd-btn primary"
            disabled={
              submitProcess ||
              (sendType === "repository" && selectedRepoDocs.length === 0) ||
              (sendType === "upload" && localDocs.length === 0)
            }
            onClick={doSubmit}
          >
            {submitProcess ? (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            ) : (
              <i className="fa fa-check mr-1" aria-hidden="true"></i>
            )}
            Attach
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CandidateReqDoc;
